import script from "./RegiaoSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./RegiaoSelect.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__